import { Fase } from '../types';
import { Users, FileText, Vote, CheckCircle, Award } from 'lucide-react';
import { calcularDatas } from '../utils/dateUtils';

export const criarFases = (dataTerminoMandato: string): Fase[] => {
  const datas = calcularDatas(dataTerminoMandato);
  
  return [
    {
      id: 'fase1',
      titulo: 'Formação da Comissão Eleitoral',
      data: datas.formacaoComissao,
      icon: Users,
      cor: 'bg-blue-500',
      prazoNR: '60 dias antes do término do mandato',
      artigo: 'Art. 5.5.2 NR-05',
      acoes: [
        'Designar membros da comissão eleitoral entre os membros atuais da CIPA',
        'Definir presidente e secretário da comissão',
        'Elaborar cronograma detalhado do processo eleitoral',
        'Preparar documentação necessária para o processo'
      ]
    },
    {
      id: 'fase2',
      titulo: 'Comunicação ao Sindicato',
      data: datas.comunicacaoSindicato,
      icon: FileText,
      cor: 'bg-green-500',
      prazoNR: '58 dias antes do término (após formação da comissão)',
      artigo: 'Art. 5.5.1.1 NR-05',
      acoes: [
        'Comunicar início do processo eleitoral ao sindicato da categoria preponderante',
        'Utilizar meio eletrônico com confirmação de entrega',
        'Manter comprovante da comunicação',
        'Aguardar eventual manifestação do sindicato'
      ]
    },
    {
      id: 'fase3',
      titulo: 'Publicação do Edital de Convocação',
      data: datas.edital,
      icon: FileText,
      cor: 'bg-purple-500',
      prazoNR: '45 dias antes do término (abertura de prazos para inscrições)',
      artigo: 'Art. 5.5.3(a) NR-05',
      acoes: [
        'Publicar edital em locais de fácil acesso e visualização',
        'Incluir todas as informações sobre o processo eleitoral',
        'Disponibilizar em meio físico ou eletrônico',
        'Divulgar amplamente entre todos os empregados'
      ]
    },
    {
      id: 'fase4',
      titulo: 'Período de Inscrições',
      data: datas.inicioInscricoes,
      dataFim: datas.terminoInscricoes,
      icon: Users,
      cor: 'bg-orange-500',
      prazoNR: '44 a 29 dias antes (15 dias corridos - mínimo exigido)',
      artigo: 'Art. 5.5.3(b) NR-05',
      acoes: [
        'Receber inscrições individuais de todos os empregados',
        'Fornecer comprovante de inscrição (físico ou eletrônico)',
        'Garantir liberdade de inscrição independente de setor',
        'Garantir estabilidade de emprego para todos os inscritos'
      ]
    },
    {
      id: 'fase5',
      titulo: 'Publicação da Lista de Candidatos',
      data: datas.publicacaoLista,
      icon: FileText,
      cor: 'bg-cyan-500',
      prazoNR: '28 dias antes (1 dia após término das inscrições)',
      artigo: 'Art. 5.5.3(e) NR-05',
      acoes: [
        'Publicar relação completa dos empregados inscritos',
        'Divulgar em locais de fácil acesso e visualização',
        'Disponibilizar em meio físico ou eletrônico',
        'Verificar dados e informações dos candidatos'
      ]
    },
    {
      id: 'fase6',
      titulo: 'Eleição (Votação)',
      data: datas.eleicao,
      icon: Vote,
      cor: 'bg-red-500',
      prazoNR: '31 dias antes do término (mínimo exigido pela NR-05)',
      artigo: 'Art. 5.5.3(f) NR-05',
      acoes: [
        'Realizar eleição em dia normal de trabalho',
        'Respeitar horários de turnos para participação da maioria',
        'Garantir voto secreto',
        'Utilizar sistema que garanta segurança e confidencialidade'
      ]
    },
    {
      id: 'fase7',
      titulo: 'Apuração dos Votos',
      data: datas.apuracao,
      icon: CheckCircle,
      cor: 'bg-green-600',
      prazoNR: '30 dias antes (1 dia após eleição)',
      artigo: 'Art. 5.5.3(i) NR-05',
      acoes: [
        'Apurar votos em horário normal de trabalho',
        'Permitir acompanhamento de representantes da organização e empregados',
        'Facultar acompanhamento dos candidatos',
        'Elaborar ata de eleição e apuração com ordem decrescente de votos'
      ]
    },
    {
      id: 'fase8',
      titulo: 'Treinamento Obrigatório',
      data: datas.inicioTreinamento,
      icon: Award,
      cor: 'bg-indigo-500',
      prazoNR: '15 dias antes do término (antes da posse)',
      artigo: 'Art. 5.7.1 NR-05',
      acoes: [
        'Promover treinamento para membros titulares e suplentes',
        'Incluir conteúdo sobre ambiente e condições de trabalho',
        'Abordar prevenção e combate ao assédio sexual',
        'Respeitar carga horária mínima conforme grau de risco'
      ]
    },
    {
      id: 'fase9',
      titulo: 'Posse dos Membros Eleitos',
      data: datas.posse,
      icon: Award,
      cor: 'bg-yellow-500',
      prazoNR: '1 dia após término do mandato anterior',
      artigo: 'Art. 5.4.7 NR-05',
      acoes: [
        'Empossar membros eleitos e designados',
        'Fornecer cópias das atas de eleição e posse',
        'Designar presidente (representante da organização)',
        'Eleição do vice-presidente (entre representantes dos empregados)'
      ]
    }
  ];
};
